<template lang="html">
	<div class="landing-quote">
		<div class="overlay">
			<div class="area">
				<div class="row justify-content-center">
					<div class="col-md-11 col-lg-10 col-xl-9">
						<div class="top-card clearfix">
							<div class="text f-l">
								Comprehensive Motor Insurance
							</div>
							<div class="close-btn f-r" @click="close">
								<div class="fa fa-times mr-1"></div>
								Close
							</div>
						</div>
						<div class="form-content-box">
							<Form
								classBinding="row line-fields"
								:ref="LandingModel.forms.sample_form.name"
								:forms="LandingModel.forms.sample_form.forms"
								:formData="LandingModel.forms.sample_form.data"
							/>
							<div class="clearfix">
								<div class="f-r">
									<button
										class="btn btn-primary"
										@form-submit="
											submitQuote({
												ref: $refs[
													LandingModel.forms
														.sample_form.name
												],
												router: $router,
											})
										"
									>
										View Results
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import quote from '../rsc/stores/landing-quote.store';

export default {
	beforeDestroy() {
		this.$store.unregisterModule('quote');
	},
	created() {
		utils.registerModule('quote', quote, this.$store);
	},
	components: {
		Form: () => import('@/libs/clarks/components/form'),
	},
	computed: {
		...mapGetters(['LandingModel', 'loading']),
	},
	methods: {
		...mapActions(['submitQuote']),
		close() {
			Event.$emit('auth:show', { quote: false });
		},
	},
	mounted() {
		utils.registerModule('quote', quote, this.$store);
	},
};
</script>

<style lang="less">
.landing-quote {
	.overlay {
		-webkit-backdrop-filter: blur(3px);
		backdrop-filter: blur(3px);
		background-color: #d6d2d2ce;
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 1200;
		overflow-y: auto;
	}

	.area {
		padding: 30px 0;
		position: absolute;
		z-index: 1500;
		left: 0;
		right: 0;

		.form-content-box {
			background: var(--white);
			padding: 15px 10px;
			margin: 20px 0 0 0;
			border-radius: 3px;
		}
		.top-card {
			background: var(--white);
			padding: 10px 20px;
			font-weight: 600;
			text-transform: uppercase;
			font-size: 14px;
			border-radius: 3px;

			.close-btn {
				color: var(--ne-red);
				cursor: pointer;
			}
		}
	}
}

// @media(max-width: 992px){
//    .login{
//       .area{
//          .blue-content{
//             position: static !important;
//             border-radius: 8px 8px 0 0;
//          }
//          .white-content{
//             margin-top: -20px;
//             border-radius: 0 0 8px 8px;
//             padding: 25px;
//          }
//       }
//    }
// }
</style>
